import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__image } from '@/utils/UTILS__image';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { useTranslation } from 'react-i18next';

export function HOOK_IMAGE__copy_to_clipboard() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);
  const { toast } = useToast();

  /*
   *
   */
  async function copy_to_clipboard(image_asset: DTO__image_asset) {
    if (image_asset.is_stub()) return;

    let url_absolute = path_relative_to_absolute(image_asset.url_relative);

    // 1. Load the image
    const tag_image = await UTILS__image.load_from_url(url_absolute);

    // 2. Draw it on a canvas
    const canvas = document.createElement('canvas');
    [canvas.width, canvas.height] = [tag_image.naturalWidth, tag_image.naturalHeight];

    const context = canvas.getContext('2d');
    assert_not_null(context);

    context.imageSmoothingEnabled = false;
    context.drawImage(tag_image, 0, 0);

    // 3. Convert to PNG blob
    const blob: Blob = await new Promise(resolve => canvas.toBlob(b => resolve(b!), 'image/png'));

    canvas.remove();

    // 4. Copy to clipboard
    const item = new ClipboardItem({ 'image/png': blob });
    await navigator.clipboard.write([item]);

    show_toast();
  }

  function show_toast() {
    toast({ title: t(i18n_base_ui.toasts.grid2d_image_copy_to_clipboard.title) });
  }

  return {
    copy_to_clipboard,
  };
}
